import React,{ useRef } from 'react';
import axios from 'axios'
import { Tooltip,Popover,Result,Table,Popconfirm,Input, Button,Collapse,Card,Avatar,Modal,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import { DeleteOutlined,SearchOutlined,CameraOutlined,PlusOutlined,EditOutlined,PlusSquareFilled,SaveOutlined,LoadingOutlined } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import {
  Col,
  Row,
} from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
import * as reactstrp from 'reactstrap';
import { ToWords } from 'to-words';

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { TextArea } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const toWords = new ToWords();

message.config({
  top: 200,
  duration: 2,
  maxCount: 3,
  rtl: true,
});




var token= ''
var sacco= ''
var username=''
var bizuserid= ''

class ReceiptToPrint extends React.Component {

  state = {
    companyprofile:{}
  };

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
    
    }else{
       sacco= ''
       username=''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })

 

  }

  render() {
    return (
      <div style={{padding:20}}>
            
          <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
          <h3 style={{color:'black'}}>{this.state.companyprofile.sacco_name}-{this.state.companyprofile.branchname}</h3>
          <h6 style={{color:'black'}}>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
          {
          this.state.companyprofile.RegisteredPhoneNumber2==""?
          "":","+this.state.companyprofile.RegisteredPhoneNumber2
          }
          {
          this.state.companyprofile.RegisteredPhoneNumber3==""?
          "":","+this.state.companyprofile.RegisteredPhoneNumber3
          }
          </h6>               
          <h5 style={{color:'black'}}>Email: {this.state.companyprofile.company_email}</h5>
          <h5 style={{color:'black'}}>Wesite: {this.state.companyprofile.website}</h5>
          <h5 style={{color:'black'}}>{this.state.companyprofile.box_number}</h5>
           <h4 style={{color:'black'}}>SLIP NO: {this.props.slipnumber}</h4>
           <h4 style={{color:'black'}}>DATE: {this.props.date}</h4>
           <h5 style={{color:'black'}}>Country: {this.state.companyprofile.country} || Currency: {this.state.companyprofile.currency}</h5>
           <h3 style={{strong:true,color:'black',fontWeight:'bolder'}}>DEPOSIT RECEIPT</h3>

           <table cellpadding="2" cellSpacing="2" border="1">
            <tr style={{height:40,padding:1}} key={1}>
              <td style={{fontWeight:'bolder'}}>ACC NUMBER</td>
              <td style={{fontWeight:'bold'}}>{this.props.account.AccountNumber}</td>
            </tr>

            <tr style={{height:40,padding:1}} key={1}>
              <td style={{fontWeight:'bolder'}}>ACC NAME</td>
              <td style={{fontWeight:'bold'}}>{this.props.account.FullName}</td>
            </tr>  

            <tr style={{height:40,padding:1}} key={1}>
              <td style={{fontWeight:'bolder'}}>DEPOSITED AMOUNT</td>
              <td style={{fontWeight:'bold'}}><CurrencyFormat  value={this.props.totalamount} displayType={'text'} thousandSeparator={true} /></td>
            </tr> 

            <tr style={{height:40,padding:1}} key={1}>
              <td style={{fontWeight:'bolder'}}>In Words</td>
              <td style={{fontWeight:'bold'}}>{ toWords.convert(this.props.totalamount)}</td>
            </tr> 

            <tr style={{height:40,padding:1}} key={1}>
              <td style={{fontWeight:'bolder'}}>PAID IN BY</td>
              <td style={{fontWeight:'bold'}}>{this.props.paidinby}</td>
            </tr> 

            <tr style={{height:40,padding:1}} key={1}>
              <td style={{fontWeight:'bolder'}}>SLIP NUMBER</td>
              <td style={{fontWeight:'bold'}}>{this.props.slipnumber}</td>
            </tr> 

            <tr style={{height:40,padding:1}} key={1}>
              <td style={{fontWeight:'bolder'}}>CONTACT</td>
              <td style={{fontWeight:'bold'}}>{this.props.transactorcontact}</td>
            </tr> 

            <tr style={{height:40,padding:1}} key={1}>
              <td style={{fontWeight:'bolder'}}>TELLER</td>
              <td style={{fontWeight:'bold'}}>{username}</td>
            </tr> 

           </table>

    </div>
    );
  }
}



class LoanSecurityTransferView extends React.Component {

  state = {
    date:moment().format(dateFormat).toString(),
    selectedaccount:'',
    selectedaccountobject:{},
    members:[],
    datarequested:true,
    totalamount:0,
    slipnumber:'',
    paidinby:'',
    transactorcontact:'',
    previoustransactions:[],
    datasubmittedsuccessfully:false,
    lastslipnumber:0,
    transferamount:0,
    sharesamount:0,
    welfareamount:0,
    emergencyamount:0,
    dreamamount:0,
    legacyamount:0,
    childrenamount:0,
    universityamount:0,
    companyprofile:{},
    accountchange:false,
    userprofile:{},
    reservetranfermode:'',

  }

  callback(key) {
    console.log(key);
  }

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
    
    }else{
       sacco= ''
       username=''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    if(localStorage.getItem("bizuserid")){
      bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
   }else{
      bizuserid= ''
   }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    let form_data1 = new FormData();
    form_data1.append('userid', bizuserid);
    
    //get the user profile here
    axios.post(serverconfig.backendserverurl+'/customqueries/get_user_profile',form_data1,{
      headers: {
        'content-type': 'multipart/form-data'
      }
      })
    .then(res => {
        this.setState({
          userprofile:res.data
        })
    })


    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })
    })

    axios.get(serverconfig.backendserverurl+`/api/members/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          members:res.data
        })
    })

    //get last slip number
    let form_data = new FormData();
    form_data.append('sacco', sacco);
    axios.post(serverconfig.backendserverurl+'/customqueries/getsaccolastslipnumber', form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
      })
    .then(res => {
        this.setState({lastslipnumber:res.data.lastnumber})
        this.setState({slipnumber:Number(res.data.lastnumber)+1})

        this.setState({datarequested:false})
    })
    .catch(error => console.log(error))

  }


  
  ////////////////////////////////////
  // PRODUCT SEARCH SELECT METHODS
   onBlur=()=> {
    console.log('blur');
  }
  
   onFocus=()=>{
    console.log('focus');
  }
  
  onSearch=(val)=> {
    console.log('search:', val);
  }

  //handle client change
  handleselectedaccountChange= (e) =>{
    this.setState({accountchange:true})
    this.setState({ selectedaccount: e});
    //make query for last transactions
    axios.get(`${serverconfig.backendserverurl}/api/members/${e}`)
      .then(res => {  
          this.setState({selectedaccountobject: res.data})
      })

      axios.get(`${serverconfig.backendserverurl}/api/transactions/?transaction_account=${e}`)
      .then(res => {  
          this.setState({previoustransactions: res.data.slice(0, 3)})
          console.log(res.data)
          this.setState({accountchange:false});
      })


      this.setState({slipnumber:Number(this.state.lastslipnumber)+1})

  }

  handlepaidinbyChange= (e) => this.setState({ paidinby: e.target.value});
  handleslipnumberChange= (e) => this.setState({ slipnumber: e.target.value});
  handletransactorcontactChange= (e) => this.setState({ transactorcontact: e});

  handletransferamountChange= (e) => this.setState({ transferamount: e});

  //sum up all the 
  calculateTotalDeposit=()=>{
    var total=this.state.transferamount+this.state.sharesamount+this.state.welfareamount+this.state.emergencyamount+
    this.state.dreamamount+this.state.legacyamount+this.state.childrenamount+this.state.universityamount

    return total;
  }

  calculateTotalShares=()=>{
    var total=Number(this.state.sharesamount)/Number(this.state.companyprofile.sharevalue)
    return total;
  }


  //submit the deposit now
  handleFormSubmit=(event) =>{
    //to security
    if(this.state.reservetranfermode==='to_loansecurity'&& this.state.transfertype==="savings" && (Number(this.state.selectedaccountobject.UserBalance)<this.state.transferamount)){
      message.error("Not enough savings to security")
    } else  if(this.state.reservetranfermode==='to_loansecurity'&& this.state.transfertype==="shares" && (Number(this.state.selectedaccountobject.sharesamount_balance)<this.state.transferamount)){
      message.error("Not enough share balance to security")
    }
    //from security
   else if(this.state.reservetranfermode==='from_loansecurity'&& this.state.transfertype==="savings" && (Number(this.state.selectedaccountobject.savingsloan_security_balance)<this.state.transferamount)){
      message.error("Not enough savings security to savings")
    }else if(this.state.reservetranfermode==='from_loansecurity'&& this.state.transfertype==="shares" && (Number(this.state.selectedaccountobject.shares_security_balance)<this.state.transferamount)){
      message.error("Not enough shares secuirty to shares")
    }
  
    else{
      this.setState({datarequested:true})
      console.log(username)
  
      let form_data = new FormData();
      form_data.append('date',moment().format(dateFormat).toString());
      form_data.append('transferamount', this.state.transferamount);
      form_data.append('sacco', sacco);
      form_data.append('account', this.state.selectedaccountobject.id);
      form_data.append('reservetranfermode', this.state.reservetranfermode);
      form_data.append('transfertype', this.state.transfertype);
      form_data.append('username', username);
      form_data.append('userid', bizuserid);

      axios.post(serverconfig.backendserverurl+'/customqueries/createloan_securitytransfer', form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
        })
      .then(res => {
        this.setState({datarequested:false})
        message.info(res.data.message)
        if (res.data.message==="success"){
          this.setState({datasubmittedsuccessfully:true})
        }

        window.location.reload(false)
        
      })
      .catch(error => console.log(error))
    }
    
  }



  ////////////////////////////////////////////
  // RENDERING METHOD HERE
  render() {

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>           </div>
      )

    }else{
      if(this.state.datasubmittedsuccessfully===true){
        return(
          <div>
            <div style={{display: "none"}}>
            &nbsp;&nbsp;
            <ReceiptToPrint
            account={this.state.selectedaccountobject} 
            totalamount={this.calculateTotalDeposit()} 
            slipnumber={this.state.slipnumber} 
            paidinby={this.state.paidinby} 
            transactorcontact={this.state.transactorcontact}
            date={this.state.date}
            ref={el => (this.componentRef = el)} /> 
            </div>

            <Row >
                  <Col xs="12" sm="6" lg="6">
                    <Card>
                    <Result
                    status="success"
                    title="Successfully transfered reserver "
                    subTitle="Please finish off transaction"
                    extra={[
                      <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
                    ]}
                    />

                   </Card>
                 </Col>
            </Row>
          </div>
        )

      }else{
        return(
          <div>
                  <Card>


                  <Row >
                  <Col xs="12" sm="6" lg="6">
                  <h4 style={{fontStyle:'oblique',fontWeight:'bolder'}}>Account to Transfer Reserve From</h4>
                    <FormItem label="Account">
                        <Select 
                        placeholder="Account No | Name" 
                        style={{  }} 
                        value={this.state.selectedaccount}
                        onChange={this.handleselectedaccountChange} 
                        showSearch
                        optionFilterProp="children"
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        onSearch={this.onSearch}
                                             
                        >
                          {this.state.members.map(
                            (accnt)=>(
                              <Option value={accnt.id}>{accnt.AccountNumber} | {accnt.FullName}</Option>
                            ))}
                        </Select>
                    </FormItem>
                  
                    {
                      this.state.accountchange?
                      <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
                      <Spin indicator={antIcon} />
                      </div>
                      :
                      null
                    }


                    <h3 style={{fontWeight:'bold',alignSelf:'center',color:'#154360'}}> SAVINGS AND SHARES LOAN SECURITY TRANSFER FORM</h3>
                    <Form
                      onFinish={(event) => this.handleFormSubmit(event)}
                    >

                  <FormItem 
                          label="Transfer type"
                          name="transfertype"
                          rules={[
                            {
                              required: true,
                              message: 'Please select transfer type',
                            },
                          ]}
                          >
                          <Select 
                          value={this.state.transfertype} 
                          onChange={(val)=>{this.setState({transfertype:val})}}
                          placeholder="Transfer Type" >
                            <Option value='savings'>Savings security</Option>
                            <Option value='shares'>Shares security</Option>
                          </Select>
                    </FormItem>


                    <FormItem 
                          label="Reserve Transfer Mode"
                          name="reservetranfermode"
                          rules={[
                            {
                              required: true,
                              message: 'Please select reserve transfer mode',
                            },
                          ]}
                          >
                          <Select 
                          value={this.state.reservetranfermode} 
                          onChange={(val)=>{this.setState({reservetranfermode:val})}}
                          placeholder="Reserve Transfer Mode" >
                            <Option value='to_loansecurity'>To loan security</Option>
                            <Option value='from_loansecurity'>From loan security</Option>
                          </Select>
                    </FormItem>


                    <FormItem label={<h6 style={{fontWeight:'bold'}}>Transfer Amount </h6>}
                    name="transferamount"
                    rules={[
                      {
                        required: false,
                        message: 'Please input amount',
                      },
                    ]}
                    
                    >
                      <InputNumber
                        style={{ width: 200 }} 
                        defaultValue={0.0}
                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/\x\s?|(,*)/g, '')}
                        onChange={this.handletransferamountChange}
                      />    
                    </FormItem>

                  <FormItem>
                    <Button  type="primary" htmlType="submit">Submit</Button>
                  </FormItem>
                  </Form>

                  </Col>
                  
                  <Col xs="12" sm="6" lg="6">
                  <h3 style={{fontWeight:'bold',color:'#154360'}}>Account Details</h3>
                    <h4>Account Number:{this.state.selectedaccountobject.AccountNumber}</h4>
                    <h4>Account Contact:{this.state.selectedaccountobject.RegisteredPhoneNumber1}</h4>
                    <h4>Account Name:{this.state.selectedaccountobject.FullName}</h4>
                    <h4>Savings balance:<CurrencyFormat value={this.state.selectedaccountobject.UserBalance} displayType={'text'} thousandSeparator={true}  /> UGX</h4>
                    <h4>Savings loan security :<CurrencyFormat value={this.state.selectedaccountobject.savingsloan_security_balance} displayType={'text'} thousandSeparator={true}  /> UGX</h4>
                    <h4>Shares number:{this.state.selectedaccountobject.sharesnumber_balance}</h4>
                    <h4>Shares amount:<CurrencyFormat value={this.state.selectedaccountobject.sharesamount_balance} displayType={'text'} thousandSeparator={true}  /> UGX</h4>
                    <h4>Shares loan security:<CurrencyFormat value={this.state.selectedaccountobject.shares_security_balance} displayType={'text'} thousandSeparator={true}  /> UGX</h4>

                  </Col>
                  
                  </Row>
               </Card>
         </div>              
                      
        )
      }
    
    }
   
  }
}

export default LoanSecurityTransferView; 
